export default __webpack_public_path__ + "static/media/iphoneRewardsScreen.131cdb21.webp";